// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  EndpointServiceResult,
  AvailableEndpointServicesListOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a AvailableEndpointServices. */
export interface AvailableEndpointServices {
  /**
   * List what values of endpoint services are available for use.
   * @param location The location to check available endpoint services.
   * @param options The options parameters.
   */
  list(
    location: string,
    options?: AvailableEndpointServicesListOptionalParams,
  ): PagedAsyncIterableIterator<EndpointServiceResult>;
}
